import { render } from "./MainRouter.vue?vue&type=template&id=a5d1f8f0&scoped=true&ts=true"
import script from "./MainRouter.vue?vue&type=script&lang=ts"
export * from "./MainRouter.vue?vue&type=script&lang=ts"

import "./MainRouter.vue?vue&type=style&index=0&id=a5d1f8f0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d1f8f0"]])

export default __exports__